$(document).ready(function () {
  $(".goTop").click(function(){
    goToElement("body");
  });
});
